<template>
  <div>
    <v-skeleton-loader
      type="image"
      v-if="!screenShotReady && checking"
    ></v-skeleton-loader>
    <div v-if="!screenShotReady && !checking" class="d-flex justify-center">
      <v-btn
        icon
        color="green"
        large
        @click="startCheckScreenshotInterval()"
      >
        <v-icon>mdi-cached</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import Constants from '../constants.json'
import axios from 'axios'

export default {
  name: 'ScreenshotSkeletonLoader',
  props: {
    screenShotReady: Boolean,
    value: Boolean,
    screenGrabId: String,
    // optionId: String,
    optionUrl: String
    // imgUrl: String
  },
  data () {
    return {
      checkScreenShotInterval: null, // Interval for checking img url is available
      checking: false
    }
  },
  computed: {
    screenShotSrc () {
      let res = null
      if (this.screenGrabId && this.screenGrabId !== 'missing') {
        // const randomQS = this.genGUID()
        res = `${Constants.SCREENSHOT_CDN}/${this.screenGrabId}.png`
      }
      return res
    },
    // screenShotFound: {
    //   // getter
    //   get: function () {
    //     return this.screenShotReady
    //   },
    //   // setter
    //   set: function (newValue) {
    //     this.$emit('update:input', newValue)
    //   }
    // }
  },
  watch: {
    // screenGrabId: function (value, oldValue) {
    //   if (value && value !== oldValue) {
    //     this.startCheckScreenshotInterval()
    //   }
    // }
    screenGrabId: { // Watch the imgUrl because this is computed each time option data is built via scraping so we can use it to re-check if the img has finished being uploaded to the CDN
      handler: function (value) {
        if (value) {
          this.startCheckScreenshotInterval()
        }
      },
      immediate: true // Make this fire immediately as well so we can use it to check first time rather than usig mounted hook as well
    }
  },
  methods: {
    startCheckScreenshotInterval: function () {
      // this.screenShotFound = false
      this.checking = true
      // repeat with the interval of 4 seconds
      this.checkScreenShotInterval = setInterval(() => this.checkScreenshotFinished(), 4000)

      // after 60 seconds stop regardles
      const self = this
      setTimeout(() => { if (this.checkScreenShotInterval) {clearInterval(self.checkScreenShotInterval); self.checking = false;} }, 60000)
    },
    checkScreenshotFinished: async function () {
      if (!this.screenShotSrc) {
        return
      }

      const checkOptionScreeshotReadyURL = `${Constants.API_BASE_PATH}/screenshot/ready`

      this.checkingContent = true

      // If not, check content has not changed
      const res = await axios.post(checkOptionScreeshotReadyURL, {url: encodeURI(this.optionUrl)}, {
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (res && res.status === 200 && res.data) {
        // console.log(JSON.stringify(res.data))
        if (res.data.screenshotFinished !== false) {
          clearInterval(this.checkScreenShotInterval)
          this.$emit('onReady')
          this.checking = false
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.screenshot-card {
  overflow-y: auto;
  overflow-x: hidden;
  position: relative !important;
}

.screenshot-image {
  max-width: 100%;
  background-size: contain;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  /* Set the size of the magnifier glass: */
  width: 150px;
  height: 150px;
  z-index: 2;
}

</style>
